module.exports = __webpack_public_path__ + "img/shopIndex-xiaochengxucode.ddb71f3b.png";